import { render } from "./altaTarjetaRegalo.vue?vue&type=template&id=f6a4a856"
import script from "./altaTarjetaRegalo.vue?vue&type=script&lang=js"
export * from "./altaTarjetaRegalo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__